export function isEmpty(value) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
}

// top right nav buttons
export function generateIcon(name) {
  var faElement = document.createElement("i");
  faElement.className = "fas fa-" + name + " text-color";
  return faElement;
}

export function generateSpanText(buttonText, classNames) {
  var spanElement = document.createElement("span");
  spanElement.innerHTML = buttonText;
  if (classNames){
    spanElement.className = classNames;
  }
  return spanElement;
}

export function openEmail(email) {
  window.open("mailto:" + email);
}

export function openDownload(url) {
  // window.location.assign(url);
  var a = document.createElement("A");
  a.href = url;
  a.target = "_blank";
  a.download = url.substr(url.lastIndexOf("/") + 1);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function openInNewTab(url) {
  var win = window.open(url, "_blank");
  win.focus();
}

export function addListener(element, eventName, handler) {
  if (element.addEventListener) {
    element.addEventListener(eventName, handler, false);
  } else if (element.attachEvent) {
    element.attachEvent("on" + eventName, handler);
  } else {
    element["on" + eventName] = handler;
  }
}

export function removeListener(element, eventName, handler) {
  if (element.addEventListener) {
    element.removeEventListener(eventName, handler, false);
  } else if (element.detachEvent) {
    element.detachEvent("on" + eventName, handler);
  } else {
    element["on" + eventName] = null;
  }
}

// filter data based on a json object. the filter must match all criteria
// (e.x. UT austin 2004)
export function filterJsonMatchAll(json, filter) {
  return json.filter(function(item) {
    for (var key in filter) {
      if (item[key] === undefined || item[key] != filter[key]) return false;
    }
    return true;
  });
}

// filter data based on a json object the filter can contain multiple or condition criteria
// (e.x. degree in marketing, communications, or history)
export function filterJsonMatchAny(json, filter_list) {
  return json.filter(function(item) {
    for (var i in filter_list) {
      for (var key in filter_list[i]) {
        if (item[key] === filter_list[i][key]) return true;
      }
    }
    return false;
  });
}

// titlecase a string
export function toTitleCase(str) {
  // break on spaces and capitalize the first element
  str = str.toLowerCase().split(/[\s]+/);
  for (var i = 0; i < str.length; i++) {
    // if element contains one or more slashes, capitalize after slash
    if (str[i].indexOf("/") !== -1) {
      var slashstr = str[i].split("/");
      for (var j = 0; j < slashstr.length; j++) {
        slashstr[j] =
          slashstr[j].charAt(0).toUpperCase() + slashstr[j].slice(1);
      }
      str[i] = slashstr.join("/");
      // if no slashes just caps by spaces
    } else {
      //dont titlecase and
      if (
        str[i].toLowerCase() !== "and" &&
        str[i].toLowerCase() !== "of" &&
        str[i].toLowerCase() !== "at"
      ) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
    }
  }
  return str.join(" ");
}

// add spaces around a dash if they don't occur
export function spaceTitleDash(str) {
  // break on spaces
  str = str.split(/[\s]+/);
  for (var i = 0; i < str.length; i++) {
    // if element contains one or more dashes space it out
    if (str[i].indexOf("-") !== -1) {
      var dashstr = str[i].split("-");
      // if there are no spaces around the dash add them
      if (str[i].indexOf(" - ") !== -1) {
        str[i] = dashstr.join("-");
      } else {
        str[i] = dashstr.join(" - ");
      }
    }
  }
  return str.join(" ");
}

//add commas to a number input
export function commafy(num) {
  var str = num.toString().split(".");
  if (str[0].length >= 5) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})$)/g, "$1,");
  }
  if (str[1] && str[1].length >= 5) {
    str[1] = str[1].replace(/(\d{3})/g, "$1 ");
  }
  return str.join(".");
}

// format a long string to use 1
export function getStringFormatThousands(rep) {
  rep = rep + ""; // coerce to string
  if (rep < 1000) {
    return Math.round(rep / 25) * 25; // round to nearest 25
  }
  // divide and format
  return (rep / 1000).toFixed(rep % 1000 != 0) + "k";
}

export function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function linspace(a, b, n) {
  if (typeof n === "undefined") n = Math.max(Math.round(b - a) + 1, 1);
  if (n < 2) {
    return n === 1 ? [a] : [];
  }
  var i,
    ret = Array(n);
  n--;
  for (i = n; i >= 0; i--) {
    ret[i] = (i * b + (n - i) * a) / n;
  }
  return ret;
}

export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
}
